import { Modal } from "react-bootstrap";
import ReactQuill from "react-quill";
export default function AboutTrack({ show, setShow, selectedAlbum }) {
  // console.log("selectedAlbum", selectedAlbum);
  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>{selectedAlbum?.title}</Modal.Header>
      <Modal.Body>
        <div
          dangerouslySetInnerHTML={{ __html: selectedAlbum?.description }}
        ></div>
      </Modal.Body>
    </Modal>
  );
}
